export default __webpack_public_path__ + "static/media/lavendar beanie.6f0d8a97.png";